import { render, staticRenderFns } from "./BudgetList.vue?vue&type=template&id=86bad0c0&"
import script from "./BudgetList.vue?vue&type=script&lang=js&"
export * from "./BudgetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports